<div class="chart-container">
  <apx-chart
    [chart]="chartOptions.chart"
    [dataLabels]="chartOptions.dataLabels"
    [fill]="chartOptions.fill"
    [labels]="chartOptions.labels"
    [legend]="chartOptions.legend"
    [plotOptions]="chartOptions.plotOptions"
    [series]="chartOptions.series"
    [stroke]="chartOptions.stroke"
  ></apx-chart>
</div>
